import moment, { Moment } from "moment-timezone";

export const convertToServerTime = (date: Moment, serverTimeZone: string, serverDateTimeFormat: string) => date.tz(serverTimeZone)
  .format(serverDateTimeFormat);

export const convertFromServerTime = (value: string | Date, serverTimeZone: string, serverDateTimeFormat: string) => {
  if (value instanceof Date) {
    moment.tz(value, serverTimeZone);
  }
  return moment.tz(value as string, serverDateTimeFormat, serverTimeZone);
};

export function formatDateStringBase(value: string | Date | null, format: string, timeZone: string, serverTimeZone: string, serverDateTimeFormat: string, invalidDate?: string | null) {
  if (!value) return "";

  const momentDate = convertFromServerTime(value, serverTimeZone, serverDateTimeFormat);

  return momentDate.isValid()
    ? (
      momentDate.tz(timeZone)
        ?.format
        ?.(format) || invalidDate
    )
    : invalidDate;
}

export function formatDateString(value: string | Date | null, format: string, timeZone: string, serverTimeZone: string, serverDateTimeFormat: string) {
  return formatDateStringBase(value, format, timeZone, serverTimeZone, serverDateTimeFormat, "Invalid date");
}

export function formatTimestamp(value: number | null, format: string, timeZone: string, invalidDate = "Invalid date") {
  if (!value) return "";

  const momentDate = moment(value);

  return momentDate.isValid()
    ? (
      momentDate.tz(timeZone)
        ?.format
        ?.(format) || invalidDate
    )
    : invalidDate;
}
